import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView } from '../utils/analytics';

/**
 * Analytics Provider Component
 * Initializes GA4 and tracks page views on route changes
 */
export const AnalyticsProvider = ({ children }) => {
  const location = useLocation();

  // Initialize GA on mount
  useEffect(() => {
    initGA();
  }, []);

  // Track page views on route change
  useEffect(() => {
    // Small delay to ensure page title is updated by React Helmet
    const timer = setTimeout(() => {
      trackPageView(location.pathname, document.title);
    }, 100);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return children;
};

export default AnalyticsProvider;
